import React from "react"

import { InfoNoticeElement } from "@front-shared/elements/infoNotice.element"

export const PayerMappingsInfoNoticeComponent: React.FunctionComponent<
    IPayerMappingsInfoNoticeComponentProps
> = props => {
    return (
        <InfoNoticeElement className={props.className}>
            {props.subject} changes take up to{" "}
            <span className="text-bold">60 seconds</span> to apply to new
            checks.
        </InfoNoticeElement>
    )
}

interface IPayerMappingsInfoNoticeComponentProps {
    subject: string
    className?: string
}
